import React, { useContext } from 'react';
import theme from '../theme/theme';
import { globalStore } from '../state/store';
import { useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Grid, InputAdornment, 
         TextField, Typography, useMediaQuery } from "@mui/material";
import { AvatarEditorWrap, BottomNav, CircularProgressCP, Header } from '../components';
import { updateUser } from '../services/userService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faTag, faCheckCircle, faTimesCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function Profile() {

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const styles = {
        hiddenBox: {
          display: 'none',
        },
        resizeBox: { 
          [theme.breakpoints.only('xs')]: { width: '320px' },
          [theme.breakpoints.up('sm')]: { width: '480px' },
          marginBottom: '20px',
        },
    }

    const navigate = useNavigate();

    const [state, dispatch] = useContext(globalStore);
    const [loading, setLoading] = React.useState(false);  
    const [isNewPhoto, setIsNewPhoto] = React.useState(false); // Needed for AvatarEditorWrap
    const [photoURL, setPhotoURL] = React.useState(Boolean(state.user) ? state.user.photoURL : null) // Needed for AvatarEditorWrap
    const [displayName, setDisplayName] = React.useState({valid: true, value: Boolean(state.user) ? state.user.displayName : '', touched: false});
    const [nickName, setNickName] = React.useState({valid: true, value: Boolean(state.user) ? state.user.nickName : '', touched: false});

    const isValid = (field, newVal) => {
        const isValid = 
            (field === 'display' && Boolean(newVal) && newVal.length >= 3 && newVal.length <= 30) ||
            (field === 'nick' && Boolean(newVal) && newVal.length >= 3 && newVal.length <= 30) 
        return isValid
    }

    const handleSubmit = () => {

        setLoading(true);

        if(!displayName.valid) {
            dispatch({ type: "NEW_SNACKBAR", payload: "Please provide a valid full name." })
            setLoading(false);
        } else if(!nickName.valid) {
            dispatch({ type: "NEW_SNACKBAR", payload: "Please provide a valid nick name." })
            setLoading(false);
        } else {

            const newUser = { 
                uid: state.user.uid,
                email: state.user.email,
                displayName: displayName.value,
                nickName: nickName.value,
                photoURL: photoURL,
                creationDate: state.user.creationDate,
                pts: Boolean(state.user.pts) ? state.user.pts : 0
            }

            updateUser(newUser) // proceed to update
            .then((resU2) => { // once updated, show snackbar

                let newLeague = state.league
                let newLeagues = state.leagues

                if(Boolean(newLeague) && Boolean(newLeague.players) && newLeague.players.length > 0) {
                    let lidx = newLeague.players.findIndex((p) => p.uid === state.user.uid);
                    newLeague.players[lidx] = resU2;

                    newLeagues.forEach((nl, i) => {
                        let nlidx = newLeagues[i].players.findIndex((p) => p.uid === state.user.uid);
                        newLeagues[i].players[nlidx] = resU2;
                    })
                }

                dispatch({ type: "CHANGE_USER", payload: resU2 })
                dispatch({ type: "INIT_LEAGUES", payload: newLeagues }) // update user details in the leagues arrays
                dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: newLeague })
                dispatch({ type: "NEW_SNACKBAR", payload: "Your profile was updated." })
                setLoading(false)

            }).catch((err) => console.log("err1x", err))

        }

    }

    return (
    <div>

      <Header page={"Profile"} />
      <BottomNav page={"Profile"} />

      <Box component="main" sx={{ flexGrow: 1, mt: isMdUp ? 8 : isSmUp ? 6 : 4, px: isMdUp ? 5 : isSmUp ? 3 : 2, py: 5 }}>

        <Box mt={1} mb={5}>
          <Typography variant="h4" align="center" sx={{mb:4}}>
            Profile
          </Typography>

          <Grid container direction="row" alignItems="center" justifyContent={"center"}>
            <Grid item xs={0} sm={1} md={2}>&nbsp;</Grid>
            <Grid item xs={12} sm={10} md={8} container justifyContent="center">

            <Grid container direction="column" justifyContent="center" alignItems="center">
          
                {loading || !Boolean(state.user) ? 
                <Grid item container direction="column" alignItems="center" sx={{mt: 5, mb:5}}>
                    <Grid item>
                        <CircularProgressCP />
                    </Grid>
                </Grid>
                :
                <Grid item container direction="column" alignItems="center" sx={{mb:2}}>

                    <Grid item sx={styles.resizeBox}>
                        
                        <AvatarEditorWrap variant={"user"} 
                        photoURL={photoURL} setPhotoURL={setPhotoURL}
                        isNewPhoto={isNewPhoto} setIsNewPhoto={setIsNewPhoto} /> 

                    </Grid>                    

                    <Grid item sx={isNewPhoto ? styles.hiddenBox : styles.resizeBox }>
                    <TextField
                    fullWidth
                    variant="outlined"
                    id="email"
                    placeholder={"Your Name..."}
                    label="Your name"
                    name="displayName"
                    autoComplete="displayName"
                    value={displayName.value}
                    onChange={e => setDisplayName({valid: isValid('display', e.target.value), value: e.target.value, touched: true})}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <FontAwesomeIcon 
                            icon={faUser} 
                            color={theme.palette.primary.main} />
                        </InputAdornment>
                        ),
                        endAdornment: displayName.touched ? (
                          <InputAdornment position="end">
                              <FontAwesomeIcon icon={displayName.valid ? faCheckCircle : faTimesCircle} 
                              style={{fontSize: '20px', marginRight: '5px', 
                                      color: displayName.valid ? theme.palette.success.main : theme.palette.error.main}} />
                          </InputAdornment>
                        ) : null
                    }}
                    />  
                    </Grid>

                    <Grid item sx={isNewPhoto ? styles.hiddenBox : styles.resizeBox}>
                    <TextField
                    fullWidth
                    variant="outlined"
                    id="email"
                    placeholder={"Nick Name..."}
                    label="Nick name"
                    name="nickName"
                    autoComplete="nickName"
                    value={nickName.value}
                    onChange={e => setNickName({valid: isValid('nick', e.target.value), value: e.target.value, touched: true})}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <FontAwesomeIcon 
                            icon={faTag} 
                            color={theme.palette.primary.main} />
                        </InputAdornment>
                        ),
                        endAdornment: nickName.touched ? (
                          <InputAdornment position="end">
                              <FontAwesomeIcon icon={nickName.valid ? faCheckCircle : faTimesCircle} 
                              style={{fontSize: '20px', marginRight: '5px', 
                                      color: nickName.valid ? theme.palette.success.main : theme.palette.error.main}} />
                          </InputAdornment>
                        ) : null
                    }}
                    />  
                    </Grid>
                    
                    <Grid item sx={isNewPhoto ? styles.hiddenBox : styles.resizeBox}>
                    <Button
                    onClick={handleSubmit}
                    type="submit"
                    disableElevation
                    variant="contained"
                    fullWidth
                    disabled={loading || isNewPhoto}
                    style={{padding: '5px 15px', fontWeight: '600', fontSize: '17px', marginBottom: '5px'}}>
                    {loading ?
                    <>Submitting...&nbsp;&nbsp;<CircularProgress size={15} /></>
                    : "Submit Update"}
                    </Button>
                    </Grid>

                    <Grid item container sx={styles.resizeBox} justifyContent="flex-end">
                        <Button onClick={e => navigate('/dashboard')}>
                            <FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Return to dashboard
                        </Button>
                    </Grid>
                    
                </Grid>
                }

            </Grid>

            </Grid>
            <Grid item xs={0} sm={1} md={2}>&nbsp;</Grid>
          </Grid>
        </Box>
    </Box>
    </div>
    );
}

export default Profile;